import React, {useMemo} from 'react';
import styled from 'styled-components';
import Document from './Document';
import ReactiveReviewModal from '../../../../../ReactiveReviewModal';
import {Each} from '../../../../../../Common/Each';

export default function EntityDocuments({
	entityUId,
	documents,
	deleteDocumentAction,
	viewKey,
	hasRelateTask,
	accountSTEntityId
}) {
	const documentsRender = useMemo(() => {
		return (
			<>
				{documents && documents.length > 0 && (
					<StyledEntityDocuments className={`StyledEntityDocuments customScrollbar`}>
						<Each
							of={documents}
							render={(document) => {
								return (
									<Document
										key={`${entityUId}-${document.id}`}
										document={document}
										entityUId={entityUId}
										deleteDocumentAction={deleteDocumentAction}
										viewKey={viewKey}
										hasRelateTask={hasRelateTask}
										accountSTEntityId={accountSTEntityId}
									/>
								);
							}}
						/>
					</StyledEntityDocuments>
				)}
			</>
		);
	}, [entityUId, documents]);

	return (
		<>
			<ReactiveReviewModal entityUId={entityUId} />
			{documentsRender}
		</>
	);
}

const StyledEntityDocuments = styled.section`
	border-top: var(--px-1) solid var(--neutrals-300);
	margin-top: var(--px-16);
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: var(--px-60);
	max-height: var(--px-220);
	.relatedDocumentsItemWrapperContainer {
		display: flex;
		width: 100%;
		padding-bottom: var(--px-16);
		border-bottom: var(--px-1) solid var(--neutrals-200);
		margin-bottom: var(--px-16);
		min-height: var(--px-40);
		&:first-child {
			margin-top: var(--px-16);
		}
		&:last-child {
			border-bottom: 0;
			margin-bottom: 0;
		}
		.relatedDocuments__row {
			width: 100%;
			padding: 0;
			.relatedDocumentDocName {
				position: relative;
				width: calc(100% - var(--px-390));
				min-height: var(--px-40);
				align-items: center;
				.DocumentNameWrapper {
					height: 100%;
					align-items: center;
					.DocumentNameContainer {
						.DocumentNameDetails {
							width: calc(100% - var(--px-30));
							&.hide-doc-icons {
								.documentName-icons {
									display: inline-flex;
								}
							}
							.DocumentName {
								width: calc(100% - var(--px-30)) !important;
								.DocuementName {
									width: 100%;
								}
							}
							.DocumentNameText {
								margin-bottom: var(--px-4);
								width: 95%;
							}
							.documentName-icons {
								color: var(--neutrals-900);
								svg {
									color: var(--neutrals-900);
									fill: var(--neutrals-900);
									path {
										fill: var(--neutrals-900);
									}
								}
								.document-checked-out-icon {
									margin-right: var(--px-10);
								}
								.StyledDisplayDocumentSignoffRequirements {
									margin-bottom: 0;
									.StyledSignoffRequirementsTrigger {
										justify-content: center;
									}
								}
							}
							.last-modified {
								font-size: var(--px-12);
								font-weight: 400;
								line-height: var(--px-15);
							}
						}
					}
					.motif-dropdown-portal {
						margin-top: 0;
					}
				}
			}
			.body-quick-reference_row_review-notes {
				padding: 0 var(--px-10);
				border-right: 0;
				height: var(--px-40);
				align-items: center;
			}
			.body-quick-reference__row__sign-offs {
				padding-top: var(--px-2);
				height: var(--px-40);
				width: var(--px-230);
				.evidenceSignOff {
					padding: 0;
				}
			}
			.ValidationImg {
				height: var(--px-32);
				width: var(--px-45);
				display: inline-flex;
				align-items: center;
				justify-content: center;
				background-color: var(--neutrals-00white);
				border: var(--px-1) solid var(--neutrals-300);
				border-radius: var(--px-20);
				padding: 0 var(--px-8);
				margin: var(--px-4) 0;
				svg {
					width: var(--px-16);
					height: var(--px-16);
					color: var(--red-600);
					fill: none;
				}
			}
			.section-validationCount {
				min-width: var(--px-60);
				.motif-dropdown-portal {
					.motif-dropdown-trigger {
						.ValidationIcon {
							background-color: var(--neutrals-00white);
							border: var(--px-1) solid var(--neutrals-300);
							border-radius: var(--px-20);
							width: var(--px-45);
							height: var(--px-32);
							display: flex;
							align-items: center;
							justify-items: center;
							.ValidationImg {
								background-color: transparent;
								border: 0;
								width: auto;
								padding: 0;
							}
							&:hover,
							&:focus {
								background-color: var(--neutrals-900);
							}
						}
					}
					&.StyledMotifDropdownPortalOpen {
						.motif-dropdown-trigger {
							.ValidationIcon {
								background-color: var(--neutrals-900);
							}
						}
					}
				}
			}
		}
	}
`;
